import React from "react"

import GenericConditionSectionEditor, { AvailableValidationInput } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/GenericConditionSectionEditor"
import MessageReceivedInput from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/GenericConditionSectionEditor/MessageReceivedInput"
import ClientTagInput from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/GenericConditionSectionEditor/ClientTagInput"
import ClientCustomFieldInput from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/GenericConditionSectionEditor/ClientCustomFieldInput"
import ClientBoardStageInput from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/GenericConditionSectionEditor/ClientBoardStageInput"
import ClientResponsibleAttendantInput from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/GenericConditionSectionEditor/ClientResponsibleAttendantInput"
import CommunicationWindowInput from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/GenericConditionSectionEditor/CommunicationWindowInput"

import useChatBotFlowConstructorStore from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/hooks/useChatBotFlowConstructorStore"

import { ChatBotFlowBlockRule } from "@/protocols/chatBot"
import useSubscriptionLimits from "@/hooks/useSubscriptionLimits"

type ConditionSectionEditorProps = {
	onSave: (chatBotFlowBlockRule: ChatBotFlowBlockRule) => void
	onDelete?: () => void
	chatBotFlowBlockRule: ChatBotFlowBlockRule
	hideChildSelection?: boolean
}

const ConditionSectionEditor: React.FC<ConditionSectionEditorProps> = (props) => {
	const {
		onSave,
		chatBotFlowBlockRule,
		children,
		hideChildSelection,
		onDelete
	} = props

	const boardSubscriptionData = useSubscriptionLimits("permission", "funnel")
	const hasAccessToBoard = !boardSubscriptionData.mustBlock
	const canUseConditionByBoardStage = hasAccessToBoard

	const chatBotFlowConstructorStore = useChatBotFlowConstructorStore()
	const isWabaChannel = chatBotFlowConstructorStore.flowData.inbox_channel_type === "waba"

	const availableValidationInputs: AvailableValidationInput = {
		"client-tag": ClientTagInput,
		"client-custom-field": ClientCustomFieldInput,
		"client-response-value": MessageReceivedInput,
		"client-responsible-attendant": ClientResponsibleAttendantInput
	}

	if (canUseConditionByBoardStage) {
		availableValidationInputs["client-board-stage"] = ClientBoardStageInput
	}

	if (isWabaChannel) {
		availableValidationInputs["communication-window"] = CommunicationWindowInput
	}

	return (
		<GenericConditionSectionEditor
			availableValidationInputs={availableValidationInputs}
			hideChildSelection={hideChildSelection}
			onSave={onSave}
			onDelete={onDelete}
			chatBotFlowBlockRule={chatBotFlowBlockRule}
			chatBotFlowBlockType="condition"
		>
			{children}
		</GenericConditionSectionEditor>
	)
}

export default ConditionSectionEditor
